import React from 'react'
import { SocialsIconListItems } from '../SocialMediaLinks'
import './socials.css'
import './socials_desktop.css'


export default function Socials() {
    return (
        <React.Fragment>
            <br /><br />
            <div className='main-content'>
                <h1>Socials</h1>
                <hr className='pglayout' />
                <ul id="socials-pg-list" className="icon-links-list">
                    <SocialsIconListItems />
                </ul>
            </div>
        </React.Fragment>
    )
}